<div class="page">
  <app-page-header page-title="companies.detail.phonebookTab.pageTitle"></app-page-header>
  <div class="page-content">
    <mat-card class="custom-card">
      <mat-card-title>{{ 'companies.detail.phonebookTab.title2' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <!-- <app-card-spinner [visible]="cardIsLoading" type="zero"></app-card-spinner> -->
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="row mb-5">
            <div class="col-12">
              <button class="navigation-button float-right" mat-flat-button color="accent" (click)="onSendByEmail()"
              *ngIf="loggedUser && loggedUserPermissions.includes('canReadPhonebookList')
                && (loggedUserRoleType === 'master' || loggedUserRoleType === 'collaborator')">
                <mat-icon fontSet="fal" fontIcon="fa-paperclip"></mat-icon>
                {{ 'properties.documentsPage.sendByEmail' | translate }}
              </button>
            </div>
          </div>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <button class="add-button mr-4" mat-raised-button color="primary" (click)="onAddPhonebookContact()"
                    *ngIf="loggedUser && loggedUserPermissions.includes('canReadPhonebookList')
                      && (loggedUserRoleType === 'master' || loggedUserRoleType === 'collaborator')"
                    matTooltip="{{ 'companies.detail.phonebookTab.add.tooltip' | translate }}">
                    <mat-icon fontSet="fal" fontIcon="fa-plus-circle"></mat-icon>
                    {{ 'common.cta.add' | translate }}
                  </button>
                  <button class="add-button mr-4" mat-raised-button color="primary" (click)="onImportPhonebookContact()"
                    *ngIf="loggedUser && loggedUserPermissions.includes('canReadPhonebookList')
                      && (loggedUserRoleType === 'master' || loggedUserRoleType === 'collaborator')"
                    matTooltip="{{ 'companies.detail.phonebookTab.add.tooltip' | translate }}">
                    <mat-icon fontSet="fal" fontIcon="fa-plus-circle"></mat-icon>
                    {{ 'common.cta.import' | translate }}
                  </button>
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #input>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInput()"
                      class="reset-input-icon" *ngIf="input.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExport()" class="d-none d-sm-inline-block"
                    style="vertical-align: super;" *ngIf="loggedUserPermissions.includes('canExportPhonebook')">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block ml-2"
                    style="vertical-align: super;">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="dataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="firstName"
                matSortDirection="asc" matSortDisableClear class="mat-elevation-z0">
                <!-- <ng-container matColumnDef="_id">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'companies.fields.user' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.userId.firstName }} {{ element.userId.lastName }} <small>{{ element.userId.email }}</small>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                  </td>
                </ng-container> -->
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="recipients">
                  <th mat-header-cell *matHeaderCellDef>
                    <button mat-icon-button
                      (click)="onToggleSelectAllContacts()"
                      matTooltip="{{ 'properties.documentsPage.sendByEmail' | translate }}">
                      <mat-icon color="accent" fontSet="far" fontIcon="fa-paperclip"></mat-icon>
                    </button>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-checkbox [checked]="selectedContactsId.indexOf(element._id) > -1"
                      (change)="onContactChanged(element, $event.checked)" class="checkbox-insert"
                      *ngIf="element.email && element.email !==''">
                    </mat-checkbox>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                  </td>
                </ng-container>

                <ng-container matColumnDef="firstName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.phonebook.firstName' | translate }} </th>
                  <td mat-cell *matCellDef="let element">{{ element.firstName }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="firstNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(firstNameFilter)"
                        class="reset-input-icon" *ngIf="firstNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="lastName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.phonebook.lastName' | translate }} </th>
                  <td mat-cell *matCellDef="let element">{{ element.lastName }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="lastNameFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(lastNameFilter)"
                        class="reset-input-icon" *ngIf="lastNameFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'companies.fields.phonebook.email' | translate }} </th>
                  <td mat-cell *matCellDef="let element">{{ element.email }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="emailFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(emailFilter)"
                        class="reset-input-icon" *ngIf="emailFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="phone">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-15">
                    {{ 'companies.fields.phonebook.phone' | translate }} </th>
                  <td mat-cell *matCellDef="let element">{{ element.phone }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="phoneFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(phoneFilter)"
                        class="reset-input-icon" *ngIf="phoneFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="mobile">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-15">
                    {{ 'companies.fields.phonebook.mobile' | translate }} </th>
                  <td mat-cell *matCellDef="let element">{{ element.mobile }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="mobileFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(mobileFilter)"
                        class="reset-input-icon" *ngIf="mobileFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="property">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-15">
                    {{ 'companies.fields.phonebook.property' | translate }} </th>
                  <td mat-cell *matCellDef="let element">{{ element.propertyId?.name }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input type="text" matInput [formControl]="propertyFilter" [matAutocomplete]="propertyAuto">
                      <mat-autocomplete autoActiveFirstOption #propertyAuto="matAutocomplete"
                        [displayWith]="displayFn.bind(this)" (onSelectionChange)="onPropertyFilterSelected($event)">
                        <mat-option *ngIf="propertyIsLoading" class="is-loading">
                          <mat-spinner diameter="50"></mat-spinner>
                        </mat-option>
                        <ng-container *ngIf="!propertyIsLoading">
                          <mat-option *ngFor="let property of availableProperties" [value]="property"
                            (onSelectionChange)="onPropertyFilterSelected($event)">
                            <small>{{ property.name }}</small>
                          </mat-option>
                        </ng-container>
                      </mat-autocomplete>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(propertyFilter)"
                        class="reset-input-icon" *ngIf="propertyFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-15">
                    {{ 'companies.fields.phonebook.type' | translate }} </th>
                  <td mat-cell *matCellDef="let element">
                    <span *ngIf="element.type === 'councilor'">{{ 'properties.fields.phonebook.councilor' | translate }}</span>
                    <span *ngIf="element.type === 'occupant'">{{ 'properties.fields.phonebook.occupant' | translate }}</span>
                    <span *ngIf="element.type === 'provider'">{{ 'properties.fields.phonebook.provider' | translate }}</span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="typeFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option value="councilor">{{ 'properties.fields.phonebook.councilor' | translate }}</mat-option>
                        <mat-option value="occupant">{{ 'properties.fields.phonebook.occupant' | translate }}</mat-option>
                        <mat-option value="provider">{{ 'properties.fields.phonebook.provider' | translate }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(typeFilter)"
                        class="reset-input-icon" *ngIf="typeFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>{{ 'common.cta.actions' | translate }}</th>
                  <td mat-cell *matCellDef="let element">
                    <button (click)="onOpenPhonebookContact(element)" mat-icon-button color="primary"
                      matTooltip="{{ 'companies.detail.phonebookTab.openTooltip' | translate }}">
                      <mat-icon fontSet="fas" fontIcon="fa-external-link"></mat-icon>
                    </button>
                    <button *ngIf="element.email && element.email !==''" (click)="onAddCommunication(element)" mat-icon-button color="accent"
                      matTooltip="{{ 'companies.detail.phonebookTab.newMessageTooltip' | translate }}">
                      <mat-icon fontSet="fas" fontIcon="fa-envelope"></mat-icon>
                    </button>
                    <button *ngIf="loggedUserRoleType === 'master' || loggedUserRoleType === 'collaborator'"
                     (click)="onRemovePhonebookContact(element)" mat-icon-button color="warn"
                      matTooltip="{{ 'companies.detail.phonebookTab.removeTooltip' | translate }}">
                      <mat-icon fontSet="fas" fontIcon="fa-trash"></mat-icon>
                    </button>
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
              </table>
              <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->